import SettingsIcon from "@mui/icons-material/SettingsOutlined";
import { Button, Stack } from "@mui/material";
import qs from "qs";
import { useNavigate } from "react-router";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import type { ApprovalConfigurationVersion, WorkflowTemplateActivity } from "../../../../../api/types/workflowTypes";
import useClientContext from "../../../../../context/useClientContext";
import { pageRoutes } from "../../../../../routes";
import WorkflowTemplateDetailsContext from "../WorkflowTemplateDetailsContext";
import WorkflowApprovalSteps from "../../approval-config/WorkflowApprovalSteps";

interface Props {
  activity: WorkflowTemplateActivity;
  approvalConfiguration: ApprovalConfigurationVersion | undefined;
}

const WorkflowApprovalCardContent = ({ activity, approvalConfiguration }: Props) => {
  const { clientCode } = useClientContext();
  const { hasEditPermissions } = useDefinedContext(WorkflowTemplateDetailsContext);
  const { workflowTemplate } = useDefinedContext(WorkflowTemplateDetailsContext);

  const navigate = useNavigate();

  const handleConfigureClick = () => {
    const isNewConfiguration = approvalConfiguration === undefined;
    const queryString = isNewConfiguration ? `?${qs.stringify({ new: true })}` : "";
    navigate(
      `/${clientCode}/${pageRoutes.workflows}/${pageRoutes.workflowTemplates}/${workflowTemplate.id}/${pageRoutes.workflowActivity}/${activity.id}${queryString}`
    );
  };

  return (
    <Stack spacing={1}>
      <WorkflowApprovalSteps
        approvalSteps={approvalConfiguration?.steps ?? []}
        userGroups={approvalConfiguration?.groups ?? []}
      />
      {hasEditPermissions && (
        <Button variant="outlined" color="secondary" startIcon={<SettingsIcon />} onClick={handleConfigureClick}>
          Configure
        </Button>
      )}
    </Stack>
  );
};

export default WorkflowApprovalCardContent;
